import React from "react";
import axios from "axios";

const Klaviyo = ({ email }) => {
  const handleOptIn = React.useCallback(async () => {
    console.log(`Initiating opt-in process for ${email}...`);
    try {
      const listId = "SkRSrD";
      const companyId = "WCvH2F";
      const endpoint = "https://a.klaviyo.com/client/subscriptions";

      const urlWithQueryParams = `${endpoint}?company_id=${companyId}`;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId,
              },
            },
          },
        },
      };

      const headers = {
        "Content-Type": "application/vnd.api+json",
        revision: "2024-10-15",
      };

      // Make the POST request
      await axios.post(urlWithQueryParams, payload, { headers });

      console.log(`Opt-in triggered successfully for ${email}`);
    } catch (error) {
      console.error("Error triggering Klaviyo opt-in:", error);
    }
  }, [email]);

  React.useEffect(() => {
    if (email) {
      handleOptIn();
    }
  }, [email, handleOptIn]);

  return <div></div>;
};

export default Klaviyo;
